import { WarningOutlined } from '@ant-design/icons';
import { granularityMatchSelector } from '@store/summaryContainer/comparison/selectors';
import { Tooltip } from 'antd';
import { useAtomValue } from 'jotai';
import React from 'react';
import { useSelector } from 'react-redux';
import { dodAtom } from '../atoms';

function CompareWarning() {
  const dodEnabled = useAtomValue(dodAtom);
  const granularityMatch = useSelector(granularityMatchSelector);
  if (dodEnabled && !granularityMatch) {
    return (
      <Tooltip title="Data granularity/interval must match for comparison period">
        <WarningOutlined style={{ fontSize: 14, color: '#faad14' }} />
      </Tooltip>
    );
  }

  return <></>;
}

export default CompareWarning;
